module.exports = __webpack_public_path__ + "img/img1.5639bb6a.jpg";